import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=3c50c786"
import script from "./Reviews.vue?vue&type=script&lang=js"
export * from "./Reviews.vue?vue&type=script&lang=js"
import style0 from "./Reviews.vue?vue&type=style&index=0&id=3c50c786&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports